module.exports = __webpack_public_path__ + "img/Flecha-izquierda.eedfff5f.svg";